import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { waDisplayNumber, waLink } from "@/lib/whatsapp";
import { Logo } from "@/components/Logo";

const INFO = [
  { to: "/custom", label: "Custom Order" },
  { to: "/tentang-kami", label: "Tentang Kami" },
  { to: "/kontak", label: "Kontak" },
  { to: "/kebijakan-pengiriman", label: "Kebijakan Pengiriman" },
  { to: "/kebijakan-pengembalian", label: "Kebijakan Pengembalian" },
  { to: "/privasi", label: "Privasi" },
  { to: "/syarat-ketentuan", label: "Syarat & Ketentuan" },
];

export const Footer = () => (
  <footer className="mt-28 bg-ink text-linen" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 py-20 pb-32 md:px-10 md:pb-20 lg:px-16">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="text-linen">
            <Logo subline="Gelang Beads Buatan Tangan" markSize={38} />
          </div>
          <p className="mt-7 max-w-sm text-sm leading-relaxed text-linen/70">
            Toko kecil gelang beads buatan tangan. Setiap desain dibuat dalam jumlah terbatas dan
            dipesan lewat WhatsApp.
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="label-eyebrow text-sand">Informasi</p>
          <ul className="mt-6 grid grid-cols-2 gap-y-3 gap-x-4">
            {INFO.map((i) => (
              <li key={i.to}>
                <Link
                  to={i.to}
                  className="link-underline text-sm text-linen/75 transition-colors duration-300 hover:text-linen"
                  data-testid={`footer-link-${i.to.replace("/", "")}`}
                >
                  {i.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="label-eyebrow text-sand">Hubungi</p>
          <ul className="mt-6 space-y-4 text-sm text-linen/75">
            <li className="flex items-center gap-3">
              <Phone size={15} strokeWidth={1.5} />
              <a
                href={waLink("Halo Zoya Beads, saya ingin bertanya.")}
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline hover:text-linen"
                data-testid="footer-whatsapp"
              >
                {waDisplayNumber()} (WhatsApp)
              </a>
            </li>
            <li className="text-xs leading-relaxed text-linen/55">
              Semua pertanyaan dan pesanan dilayani lewat WhatsApp.
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-linen/15 pt-8 text-xs text-linen/50 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Zoya Beads.</p>
        <p>Harga dalam Rupiah (IDR) · Kirim ke seluruh Indonesia</p>
      </div>
    </div>
  </footer>
);
